import React from "react";

const Card = ({ label, value, sublabel, testId }) => (
    <div
        className="rounded-xl border border-border-subtle bg-elevated p-5"
        data-testid={testId}
    >
        <p className="text-[11px] uppercase tracking-widest-2 text-text-muted">
            {label}
        </p>
        <p
            className="mt-3 font-display text-[clamp(28px,3vw,40px)] font-semibold leading-none tracking-tight-2"
            style={{ color: "#E8FFD8" }}
        >
            {value}
        </p>
        {sublabel && (
            <p className="mt-2 text-[12.5px] text-text-muted">{sublabel}</p>
        )}
    </div>
);

const topEntry = (obj = {}) => {
    let topKey = null;
    let topVal = 0;
    for (const [k, v] of Object.entries(obj || {})) {
        if (v > topVal) {
            topKey = k;
            topVal = v;
        }
    }
    return [topKey, topVal];
};

const DIVISION_LABEL = {
    funding: "Funding",
    realestate: "Real Estate",
    materials: "Materials",
    consulting: "Consulting",
    contact: "Contact",
};

export const StatsCards = ({ stats }) => {
    if (!stats) {
        return (
            <div
                className="grid grid-cols-2 gap-4 lg:grid-cols-4"
                data-testid="admin-stats-cards-skeleton"
            >
                {Array.from({ length: 4 }).map((_, i) => (
                    <div
                        key={i}
                        className="h-[120px] animate-pulse rounded-xl border border-border-subtle bg-elevated"
                    />
                ))}
            </div>
        );
    }
    const [topDiv, topDivCount] = topEntry(stats.byDivision);
    const [topSrc, topSrcCount] = topEntry(stats.byUtmSource);
    return (
        <div
            className="grid grid-cols-2 gap-4 lg:grid-cols-4"
            data-testid="admin-stats-cards"
        >
            <Card
                label="Total Leads"
                value={stats.totalLeads}
                testId="stat-total"
            />
            <Card
                label="New Today"
                value={stats.newLeadsToday}
                testId="stat-today"
            />
            <Card
                label="Top Division"
                value={topDiv ? DIVISION_LABEL[topDiv] || topDiv : "—"}
                sublabel={topDiv ? `${topDivCount} leads` : ""}
                testId="stat-top-div"
            />
            <Card
                label="Top Source"
                value={topSrc || "—"}
                sublabel={topSrc ? `${topSrcCount} leads` : ""}
                testId="stat-top-source"
            />
        </div>
    );
};

export default StatsCards;
